import { createSlice } from '@reduxjs/toolkit';
import { initialState } from './types';
export const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    enableNurserySelected: (state) => {
      return {
        ...state,
        nurserySelected: true,
      };
    },
    disableNurserySelected: (state) => {
      return {
        ...state,
        nurserySelected: false,
      };
    },
    enableDashboardLoading: (state) => {
      return {
        ...state,
        dashboardLoading: true,
      };
    },
    disableDashboardLoading: (state) => {
      return {
        ...state,
        dashboardLoading: false,
      };
    },
    enableDashboardError: (state) => {
      return {
        ...state,
        dashboardError: true,
      };
    },
    disableDashboardError: (state) => {
      return {
        ...state,
        dashboardError: false,
      };
    },
  },
});

export const {
  enableNurserySelected,
  disableNurserySelected,
  enableDashboardLoading,
  disableDashboardLoading,
  enableDashboardError,
  disableDashboardError,
} = dashboardSlice.actions;
export default dashboardSlice.reducer;
